import request from '@/api/request'
//获取广告位位置信息 --无分页（前台展示）
export function List(params) {
	return request({ url: '/h5/advertising/getAdvertisingPositionList',method: 'get',data: params})
}
export function infoDetail(params) {
	return request({ url: '/h5/advertising/getAdvertisingPositionInfo',method: 'get',data: params})
}
// export function AreaList(params) {
// 	return request({ url: '/h5/advertising/getArea',method: 'get',data: params})
// }
export function AreaList(params) {
	return request({ url: '/h5/advertising/getAdvertisingAreaList',method: 'get',data: params})
}

// export function TypeList(params) {
// 	return request({ url: '/h5/advertising/getType',method: 'get',data: params})
// }
export function TypeList(params) {
	return request({ url: '/h5/advertising/getAdvertisingTypeList',method: 'get',data: params})
}
export function Appointment(params) {
	return request({ url: '/h5/consult/insertConsult',method: 'post',data: params})
}